import { render, staticRenderFns } from "./reset_account_pwd.vue?vue&type=template&id=c130c3f6&scoped=true&"
import script from "./reset_account_pwd.vue?vue&type=script&lang=js&"
export * from "./reset_account_pwd.vue?vue&type=script&lang=js&"
import style0 from "./reset_account_pwd.vue?vue&type=style&index=0&id=c130c3f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c130c3f6",
  null
  
)

export default component.exports